import React, { useContext } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import Pane from 'components/Common/Pane'
import LoadingIndicator from 'components/Common/Loading/LoadingIndicator'
import TextButton from 'components/Luxkit/Button/TextButton'
import useBedbankRates from 'hooks/useBedbankRates'
import useFlightPrice from 'hooks/useFlightPrice'
import OfferPageStateContext from 'contexts/OfferPage/offerPageStateContext'
import WalledContent from 'components/Common/WalledContent'
import BedbankSummaryPriceDetails from './BedbankSummaryPriceDetails'
import useBedbankOfferSell from 'hooks/useBedbankOfferSell'
import Group from 'components/utils/Group'
import { useBusinessTravellerStickyBudgetBarHeightContext } from 'businessTraveller/utils/useBusinessBudgetBarHeightContext'

const SummaryPane = styled(Pane)`
  padding: ${rem(28)} ${rem(20)};
  position: relative;
  border: 1px solid ${({ theme }) => theme.palette.neutral.six};
  border-radius: ${props => props.theme.borderRadius.small};
  width: ${rem(342)};
`

const RelativeBlock = styled.div`
  position: relative;
`

interface Props {
  checkinDate: moment.Moment;
  checkoutDate: moment.Moment;
  className?: string;
  offer: App.BedbankOffer;
  onViewPackageOptions?: () => void;
  rooms: Array<App.Occupants>;
  flightsEnabled: boolean;
  duration: number;
  loadingPrices?: boolean;
}

function BedbankOfferSummary(props: Props) {
  const {
    checkinDate,
    checkoutDate,
    className,
    offer,
    onViewPackageOptions,
    rooms,
    loadingPrices,
    flightsEnabled,
    duration,
  } = props

  const { airport } = useContext(OfferPageStateContext)

  const [rates] = useBedbankRates(offer.id, rooms, checkinDate, checkoutDate)
  const sell = useBedbankOfferSell(offer, duration)
  const hotelNights = rates[0]?.nights ?? sell?.los
  const [flightPrice] = useFlightPrice(offer.flights?.airportCode, rooms, checkinDate, checkoutDate, airport?.code, hotelNights)
  const businessTravellerStickyBudgetBarStyle = useBusinessTravellerStickyBudgetBarHeightContext()

  return (
    <SummaryPane style={businessTravellerStickyBudgetBarStyle} type="clean" shadow className={className} data-testid="SummaryPane">
      <Group direction="vertical" gap={12}>

        <WalledContent enforced={offer.walledGarden && !sell}>
          {(rates.length > 0 || sell) &&
            <RelativeBlock>
              <LoadingIndicator floating opaque backdrop="grey-light" visible={loadingPrices} />
              <BedbankSummaryPriceDetails
              rate={rates[0]}
              rooms={rooms}
              offer={offer}
              duration={duration}
              flightPrice={flightPrice}
              flightsEnabled={flightsEnabled}
              onViewPackageOptions={onViewPackageOptions}
            />
            </RelativeBlock>
        }
        </WalledContent>
        <TextButton kind="primary" fit="flex" onClick={onViewPackageOptions}>
          View package options
        </TextButton>
      </Group>
    </SummaryPane>
  )
}

export default React.memo(BedbankOfferSummary)
